import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { AddinfoService, ApiProductsService, NotificationService } from 'src/app/services';
import { ApiMainSettingsService } from 'src/app/services/api-main-settings.service';

@Component({
  selector: 'app-product-create',
  templateUrl: './product-create.component.html',
  styleUrls: ['./product-create.component.css']
})
export class ProductCreateComponent implements OnInit {

  progressRef: NgProgressRef;
  apiSettings: ApiMainSettingsService;

  constructor(
    private apiProducts: ApiProductsService,
    public ngProgress: NgProgress,
    private router: Router,
    private notification: NotificationService,
    private addinfoService: AddinfoService,
  ) { }

  ngOnInit(): void {
    this.progressRef = this.ngProgress.ref('progress-bar');
  }


   //
   onCreate(){

    // Проверяем обязательные поля до отправки — чтобы бэкенд не падал с DataIntegrityViolationException
    const missing = this.addinfoService.getMissingRequiredFields();

    if (missing.length > 0) {

      const preview = missing.slice(0, 5).join(', ');
      const suffix = missing.length > 5 ? ` и ещё ${missing.length - 5}` : '';
      this.notification.show('warning', `Заполните обязательные поля: ${preview}${suffix}`);
      this.addinfoService.focusFirstMissingRequiredField();
      return;
    }

    this.progressRef.start();

    let data = {
      addinfo: this.addinfoService.getAdinfoFormValue()
    }

    // data.basis['signed_xml'];

    this.apiProducts.save(data).subscribe(response => {

      if (response != null) {

        this.router.navigate(['products']);
        this.notification.show('success', 'Данные успешно сохранены!');
      }
      this.progressRef.complete();
    });
  }

  backTo () {
  
        
    this.router.navigate(['settings']);
  
    setTimeout(()=> this.apiSettings.switchTab('subscriptions'),1500)
    
  
  }
  
}

